'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

require('picturefill');

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

require('angular-gettext');

require('@uirouter/angularjs');

require('angular-resource');

require('ng-file-upload');

require('ng-lodash');

require('ngstorage');

require('angular-dynamic-locale');

require('@iamadamjowett/angular-click-outside');

require('angular-aria');

require('angular-slick-carousel');

require('angular-youtube-embed');

require('angular-picture');

require('angular-toastr');

require('tether');

var _core = require('./core');

var _core2 = _interopRequireDefault(_core);

var _directives = require('./directives');

var _directives2 = _interopRequireDefault(_directives);

var _filters = require('./filters');

var _filters2 = _interopRequireDefault(_filters);

var _models = require('./models');

var _models2 = _interopRequireDefault(_models);

var _services = require('./services');

var _services2 = _interopRequireDefault(_services);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.common', [
// 3rd party dependencies
'gettext', 'ui.router', 'ngResource', 'ngLodash', 'ngDialog', 'ngStorage', 'ngLocale', 'tmh.dynamicLocale', 'angular-click-outside', 'toastr', 'ngAria', 'slickCarousel', 'youtube-embed', 'angular-google-analytics', 'ngPicturefill',

// own dependencies
_core2.default, _directives2.default, _filters2.default, _models2.default, _services2.default]);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./common/index.js
// module id = 256
// module chunks = 0